import { Rule } from '../rule.js'

export default [
  Rule({
    details: {
      id: 'default-graphic',
      title: 'Default',
      description: 'Graphics colors are used for...',
      isInternal: true
    },
    props: {
      type: 'graphic'
    },
    type: 'collection'
  }),

  Rule({
    details: {
      id: 'default-decoration',
      slug: null,
      title: 'Ungrouped',
      isInternal: true
    },
    props: {
      type: 'decoration'
    },
    type: 'collection'
  }),
  Rule({
    details: {
      id: 'default-fill',
      slug: 'default',
      title: 'Ungrouped',
      isInternal: true
    },
    props: {
      type: 'fill'
    },
    type: 'collection'
  }),
  Rule({
    details: {
      id: 'default-spacing',
      slug: 'default',
      title: 'Ungrouped',
      isInternal: true
    },
    props: {
      type: 'spacing'
    },
    type: 'collection'
  }),
  Rule({
    details: {
      id: 'default-typography',
      slug: 'default',
      title: 'Ungrouped',
      isInternal: true
    },
    props: {
      type: 'typography'
    },
    type: 'collection'
  })
]
